<template>
  <div>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-xs-12 content container-fluid">
      <h1>Solicitudes Productos</h1>
      <div class="wrapper">
        <div class="container-wrapper">
          <div id="alerts-container"></div>
        </div>
      </div>
      <div id="app" class="ui vertical stripe segment">
        <div class="row">
          <div class="col-xs-12 m-t-20">
            <div class="table-responsive">
              <div id="content" class="ui basic segment">
                <table
                  id="table-with-sorting"
                  class="table data-table with-sorting table-striped tablesorter payment-batch-table sortable"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Fecha</th>
                      <th>Empleado</th>
                      <th>Compañia</th>
                      <th>Ofertas</th>
                      <th>Proveedor</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loadingTable">
                    <tr v-for="transaction in transactions">
                      <td>{{ transaction.id }}</td>
                      <td>{{ transaction.created_at }}</td>
                      <td>{{ transaction.fullname }}</td>
                      <td>{{ transaction.company.name }}</td>
                      <td>{{ transaction.offer.title }}</td>
                      <td>{{ transaction.provider.name }}</td>
                      <td>
                        <a
                          class="btn btn-primary btn-xs"
                          data-toggle="modal"
                          data-target="#transaction-info-{{ transaction.id }}"
                        >
                          Informacion</a
                        >

                        <a
                          @click="approved(transaction)"
                          class="btn btn-success btn-xs"
                          >Aprobar</a
                        >
                        <a
                          @click="cancel(transaction)"
                          class="btn btn-danger btn-xs"
                          >Cancelar</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <template v-if="loadingTable">
                  <div style="text-align: center">
                    <span class="fa fa-spin fa-spinner"></span>
                  </div>
                </template>
              </div>
            </div>
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
      <div class="copyright">
        2016 &copy; Cash Depot - Todos los derechos reservados.
      </div>
    </footer>

    <div
      v-for="transaction in transactions"
      class="modal fade"
      id="transaction-info-{{transaction.id}}"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"> &times; </span>
            </button>
            <h4 class="modal-title">Información de la transacción</h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>ID Transaccion:</td>
                  <td>{{ transaction.id }}</td>
                </tr>
                <tr>
                  <td>Nombre Empleado:</td>
                  <td>{{ transaction.fullname }}</td>
                </tr>
                <tr>
                  <td>Compañia:</td>
                  <td>{{ transaction.company.name }}</td>
                </tr>
                <tr>
                  <td>Productos:</td>
                  <td>
                    {{ transaction.provider.name }} -
                    {{ transaction.offer.title }}
                  </td>
                </tr>
                <tr>
                  <td>Cantidad:</td>
                  <td>{{ transaction.quantity }}</td>
                </tr>
                <tr>
                  <td>Valor de la Oferta:</td>
                  <td>{{ transaction.offer.amount | currency }}</td>
                </tr>
                <tr
                  v-show="
                    transaction.credit_limit.limit_of_credit <
                    transaction.due_amount * transaction.total_splits
                  "
                >
                  <td>Disponible para Credito al ({{ getNow() }}):</td>
                  <td>
                    {{ transaction.credit_limit.limit_of_credit | currency }}
                  </td>
                </tr>
                <tr>
                  <td>Pagar Contra Entrega:</td>
                  <td>{{ transaction.invoice_payment | currency }}</td>
                </tr>
                <tr>
                  <td>Total a Financiar:</td>
                  <td>
                    {{
                      (transaction.due_amount * transaction.total_splits)
                        | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Descuento:</td>
                  <td>{{ transaction.offer.discount_percent }} %</td>
                </tr>
                <tr>
                  <td>Facilidad de Pago:</td>
                  <td>{{ transaction.total_splits }}</td>
                </tr>
                <tr>
                  <td>Cargo por Financiamiento:</td>
                  <td>{{ transaction.interest_amount | currency }}</td>
                </tr>
                <tr>
                  <td>Monto de Cuotas:</td>
                  <td
                    v-show="
                      transaction.due_amount <
                      transaction.credit_limit.maximum_discount[3]
                    "
                  >
                    {{ transaction.due_amount | currency }}
                  </td>
                  <td
                    v-show="
                      transaction.due_amount >
                      transaction.credit_limit.maximum_discount[3]
                    "
                  >
                    El Valor de la cuota es de
                    {{ transaction.due_amount | currency }} pero el cliente
                    tiene un maximo de
                    {{
                      transaction.credit_limit.maximum_discount[3] | currency
                    }}
                    para descuento
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
          </div>
          <div class="modal-footer text-center">
            <div class="row">
              <div class="col-md-12">
                <a data-dismiss="modal" class="btn btn-bgrey">Cerrar</a>
                <a @click="approved(transaction)" class="btn btn-success"
                  >Aprobar</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_url: `http://api.cashdepotint.com/v1`,
      checkedComment: [],
      validity: "",
      loadingTable: true,
      transactions: [],
      visibleColumns: [],
      vid: false,
      selectedColumns: "",
      user_id: "",
    };
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }

    this.getTransactions();
  },
  methods: {
    getTransactions: function () {
      this.$http.get(apiUrl + `/transactions?q=(status:0)`).then(
        (response) => {
          this.transactions = response.body;
          this.loadingTable = false;
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "Ha ocurrido un error al cargar las transacciones !",
            "error"
          );
        }
      );
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      return date;
    },
    approved(transaction) {
     
        this.loadingTable = true;
        this.$http
          .post(apiUrl + `/transactions/generate-loans/` + transaction.id)
          .then(
            (response) => {
              sweetAlert(
                "Todo correcto",
                "Se ha generado la deuda del empleado",
                "success"
              );
              this.getTransactions();
              this.loadingTable = false;
            },
            (response) => {
              sweetAlert(
                "Oops...",
                "Ha ocurrido un error al procesar la transaccion !",
                "error"
              );
              this.loadingTable = false;
            }
          );
    },
    cancel(transaction) {
        this.loadingTable = true;

        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + `/transactions/` + transaction.id + `/status`,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: { status: 2 },
        }).then(
          function (response) {
            sweetAlert("Todo correcto", "Transaccion cancelada", "success");
            this.getTransactions();
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
          }
        );
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// index.vue?65c50eb8